
namespace appn.burgerMenu {

    export function init(): void {
        extractAndBuildBoxHeaderIconBtns();
        addEvents();
    }

    function addEvents() {
        // Always clean the burger menu on click of the ... button.  
        // This helps us avoid having to remember to do this manually in separate files.
        $('.btn[data-toggle="dropdown"]').on('click', function(event) {
            cleanBurgerMenu($(this).closest('.appn-dropdown-btn').find('ul.dropdown-menu'));
        });
    }

    function extractAndBuildBoxHeaderIconBtns(): void {
        const boxesWithBurgerMenus = $('.card .card-tools .appn-burger-menu');

        // Loop through all box burger menus
        $.each(boxesWithBurgerMenus, function(index: number, burgerMenu: HTMLElement) {
            // clear values to stop duplication

            const dropdownIconBtns = $(burgerMenu).find('ul.dropdown-menu li[data-boxheadericonbtnorder]');

            if (dropdownIconBtns.length === 0)
                return; // bail early since there are no btn icons to extract

            const cardTools = burgerMenu.closest('.card-tools') as HTMLElement;

            let iconBtnList: Array<{index: number, element: HTMLElement | undefined}> = [];

            $.each(dropdownIconBtns, function(index2: number, iconBtnLi: any) {
                const iconBtnOrderValue = $(iconBtnLi).data('boxheadericonbtnorder');
                if (iconBtnOrderValue) {
                    const iconClass = extractFontAwesomeIconClasses($(iconBtnLi).find('i'));
                    const dataValues = extractDataValues($(iconBtnLi).find('button'));
                    iconBtnList.push({
                            index: Number(iconBtnOrderValue),
                            element: buildBoxIconBtn(iconClass, extractTitleText($(iconBtnLi)), extractActionClasses($(iconBtnLi)), dataValues, extractButtonAttributes($(iconBtnLi).find('button')))
                        });
                }
            });

            iconBtnList = iconBtnList.sort((a, b) => {
                return a.index - b.index;
            }); // filter and reverse the order of the results

            iconBtnList.forEach((iconBtn: { index: number, element: HTMLElement | undefined; }, index: number, original: Array<{ index: number, element: HTMLElement | undefined; }>) => {
                if (iconBtn && iconBtn.element)
                    cardTools.prepend(iconBtn.element);
            });
        });

        appn.tooltip.init();
    }

    function extractTitleText(element: JQuery<HTMLElement>): string {
        return element.find('span').text();
    }

    function extractActionClasses(element: JQuery<HTMLElement>): string {

        let buttonOrAtag = element.find('a') as any;
        if (buttonOrAtag.length === 0)
            buttonOrAtag = element.find('button');

        if (buttonOrAtag.length === 0)
            return appn.emptyString;

        const classList = buttonOrAtag.attr('class');
        if (!classList)
            return appn.emptyString;

        // Creating class array by splitting class list string
        const classArr = classList.split(/\s+/);

        let actionClasses = appn.emptyString;

        $.each(classArr, function(index, value) {
            if (value.startsWithIgnoreCase('tooltip') || value.startsWithIgnoreCase('d-flex') || value.startsWithIgnoreCase('justify-content-between') || value.startsWithIgnoreCase('align-items-center'))
                return true;

            actionClasses += `${value} `;
        });

        return actionClasses;
    }

    function extractButtonAttributes(element: JQuery<HTMLElement>): { type: string | undefined, name: string | undefined, value: string | undefined } | undefined {
        if (!element)
            return;

        return {
            type: element.attr('type'),
            name: element.attr('name'),
            value: element.attr('value')
        };
    }

    function buildBoxIconBtn(icon: string, hoverText: string, classes: string, data: Array<KeyValue> = [], buttonAttributes?: { type: string | undefined, name: string | undefined, value: string | undefined; }): HTMLElement {
        const boxIcon = document.createElement('i');
        boxIcon.className = icon;

        const button = document.createElement('button');
        button.title = hoverText;
        button.type = 'button';
        button.className = `btn btn-tool ${classes}`;

        if (buttonAttributes) {
            if (buttonAttributes.type)
                button.type = buttonAttributes.type == 'submit' || buttonAttributes.type == 'reset' ? buttonAttributes.type : 'button';

            if (buttonAttributes.name)
                button.name = buttonAttributes.name;

            if (buttonAttributes.value)
                button.value = buttonAttributes.value;
        }

        if (data.length > 0)
            data.forEach((pair: KeyValue) => {
                button.setAttribute(pair.key, pair.val);
            });

        button.appendChild(boxIcon);

        return button;
    }

    function extractFontAwesomeIconClasses(element: JQuery<HTMLElement>): string {
        const classList = element.attr('class');
        if (!classList)
            return appn.emptyString;

        // Creating class array by splitting class list string
        const classArr = classList.split(/\s+/);

        let faIconClass = appn.emptyString;

        $.each(classArr, function(index, value) {
            if (value === 'fa')
                faIconClass += `${value} `;

            if (value === 'fad')
                faIconClass += `${value} `;

            if (value.startsWithIgnoreCase('fa-'))
                if (value.containsIgnoreCase('fa-toggle-off'))
                    faIconClass += 'fa-toggle-on ';
                else if (value.containsIgnoreCase('fa-toggle-on'))
                    faIconClass += 'fa-toggle-off ';
                else
                    faIconClass += `${value} `;


            if (value.startsWithIgnoreCase('rotate-'))
                faIconClass += `${value} `;

            if (value.startsWithIgnoreCase('text-'))
                faIconClass += `${value} `;
        });

        return faIconClass;
    }

    function extractDataValues(element: JQuery<HTMLElement>): Array<KeyValue> {
        const dataPairs: Array<KeyValue> = [];

        if (element.get(0) === undefined)
            return dataPairs;

        const attributes = element.get(0)?.attributes;

        if (!attributes)
            return [];

        $.each(attributes, function(index, attr) {
            if (attr.name.startsWith('data'))
                dataPairs.push({ key: attr.name, val: attr.value, index: index });
        });

        return dataPairs;
    }

    function cleanBurgerMenu(ul: JQuery<HTMLElement>): void {
        // Do not automatically try this cleanup if there are unformatted children (TaskTemplate/Connectors for example)
        if (ul.children().length !== ul.find('>li').length)
            return;

        const burgerList: Array<BurgerListItem> = [];

        ul.find('li').each((index: number, listItem: HTMLElement) => {
            const itemType = $(listItem).hasClass('dropdown-divider') ? 'divider' : 'item';

            burgerList.push({
                item: $(listItem),
                type: itemType,
                action: itemType === 'item' ? $(listItem).find('a,button') : undefined,
                visible: (itemType === 'item' && $(listItem).find('a,button').hasClass('d-none')) || (itemType === 'divider' && $(listItem).hasClass('d-none')) ? false : true
            });
        });

        // Only check visible items
        burgerList.filter((item: BurgerListItem) => {
            return item.visible === true;
        }).forEach((listItem: BurgerListItem, index: number, burgerList: Array<BurgerListItem>) => {
            if (!listItem.visible)
                return;

            if (listItem.type === 'divider' && index === 0 && listItem.visible) { // if the divider is the first thing visible
                listItem.item.hideElement();
                burgerList[index].visible = false;
                return;
            }

            if (listItem.type === 'divider' && index > 0 && burgerList[index - 1] && burgerList[index - 1].type === 'divider' && burgerList[index - 1].visible) {
                burgerList[index - 1].item.hideElement();
                burgerList[index - 1].visible = false;
            }
        });

        log.info('Burger menu has been cleaned.');
    }

    interface BurgerListItem {
        item: JQuery<HTMLElement>;
        type: string;
        action: JQuery<HTMLElement> | undefined;
        visible: boolean;
    }
}
